var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","width":"100%","height":"100%"}},[(!_vm.isCity)?_c('div',{ref:"sctterMap",staticStyle:{"width":"100","height":"100%"}}):_c('SuperMap',{staticClass:"superMap",attrs:{"adcode":_vm.adcode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }